import ConfirmModalContent from "@components/common/ConfirmModalContent";
import useCustomerDetails from "@hooks/Customers/useCustomerCreateEdit";
import { Customer } from "@interfaces/customer";
import { t } from "i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CustomerDetails } from "@components/customer/Customer.types";

interface CustomerConfirmPopupProps {
  showModal: () => void;
  data: Customer;
  isDraft?: boolean;
  customerId?: string;
  oldData?: CustomerDetails | undefined;
}

const CustomerConfirmPopup = ({
  data,
  isDraft,
  showModal,
  customerId,
  oldData,
}: CustomerConfirmPopupProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(true);
  const { addCustomer, isLoading, updateCustomer, updateCustomerDetails } =
    useCustomerDetails();
  const navigate = useNavigate();
  const close = () => {
    setShowConfirmModal(false);
    showModal();
  };
  const onConfirm = () => {
    if (isDraft) {
      updateCustomer(data, customerId, true, true, oldData).then((response) => {
        if (response.status === "success") {
          setShowConfirmModal(false);
          navigate("/customers/" + customerId + "/view");
        } else if (response.status === "error") {
          setShowConfirmModal(false);
        }
      });
    } else {
      addCustomer(data).then((response) => {
        if (response.status === "success") {
          if (response?.customerData.id) {
            const customer_id = response?.customerData.id;
            updateCustomerDetails(response?.customerData.id, data).then(
              (response) => {
                if (response.status === "success") {
                  setShowConfirmModal(false);
                  navigate("/customers/" + customer_id + "/view");
                } else if (response.status === "error") {
                  setShowConfirmModal(false);
                }
              }
            );
          }
        } else if (response.status === "error") {
          setShowConfirmModal(false);
        }
      });
    }
  };

  return (
    <ConfirmModalContent
      heading={t("core:customers:confirm_popup.heading")}
      body=""
      message={t("core:customers:confirm_popup.message")}
      confirmBtnText={
        t("core:customers:confirm_popup.confirmMessage") || undefined
      }
      cancelBtnText={
        t("core:customers:confirm_popup.cancelMessage") || undefined
      }
      onConfirm={onConfirm}
      loading={isLoading}
      onCancel={close}
      isOpen={showConfirmModal}
      onClose={close}
    />
  );
};
export default CustomerConfirmPopup;
